<div class="login-card">
    <div>
        <div class="login-main">
            <div class="theme-form needs-validation">
                <h4 style=" font-size: 22px;margin-bottom:20px">Log in to mygistec</h4>
                <div *ngIf="showLogin">
                    <div class="form-group">
                        <label class="col-form-label">Enter your Email Address:</label>
                        <input [(ngModel)]="userName" class="form-control" type="email" required="" placeholder="name@company.com">
                        <div class="invalid-feedback">Email is required.</div>
                        <div class="invalid-feedback">Invalid Email Address.</div>
                    </div>
                    <div class="form-group mb-0">
                        <button [disabled]="btnDisabled" (click)="continue_email()" class="btn btn-primary d-block w-100" type="button">Continue</button>
                    </div>
                </div>
                <div *ngIf="showOTP">
                    <label class="col-form-label">Enter the code we sent over Email to {{otp_emailAddress}}:</label>
                    <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="{length:6}"></ng-otp-input>
                    <div class="form-group mb-0" style="margin-top:10px">
                        <button [disabled]="btnDisabled" (click)="continue_otp()" class="btn btn-primary d-block w-100" type="button">{{otp_button_text}}</button>
                    </div>
                    <p class="mt-4 mb-0" *ngIf="EnablePasswordLogin">
                        <a style="cursor:pointer" (click)="showPasswordPanel()" class="ms-2">Or Login using Password</a>
                    </p>
                </div>
                <div *ngIf="showPasswordLogin">
                    <label class="col-form-label" style="margin-top: 20px;">Enter your password:</label>
                    <div class="form-group">
                        <input class="form-control" [(ngModel)]="password" type="password" placeholder="*********">
                    </div>
                    <div class="form-group mb-0">
                        <button [disabled]="btnDisabled" (click)="login_password()" class="btn btn-primary d-block w-100" type="button">{{password_button_text}}</button>
                    </div>
                    <p class="mt-4 mb-0">
                        <a (click)="showOTPPanel()" class="ms-2">Or Login using OTP</a>
                    </p>
                </div>
                <div *ngIf="showUpdateMobileNumber">
                    <p>It seems that your mobile number is not updated on mygistec, please provide your mobile number</p>
                    <div class="form-group">
                        <form class="example-form" style="padding: 0px;" [formGroup]="mobileLoginForm">
                            <ngx-mat-intl-tel-input style="background-color: #f3f3ff !important;" class="form-control" [preferredCountries]="['ae', 'sa', 'jo']"
                                                    [enablePlaceholder]="true"
                                                    [enableSearch]="true"
                                                    name="phone" formControlName="phone"
                                                    describedBy="phoneInput"></ngx-mat-intl-tel-input>
                        </form>
                    </div>
                    <div class="form-group mb-0">
                        <button [disabled]="btnDisabled" (click)="save_mobile_login()" class="btn btn-primary d-block w-100" type="button">Save and Log in</button>
                    </div>

                </div>
                


                <h6 style=" font-size: 16px;" class="text-muted mt-4 or">Or Sign in with</h6>
                <app-continue-with [isEmailLogin]="'false'"></app-continue-with>
                <p class="mt-4 mb-0">
                    Need help?
                    <a [routerLink]="'/auth/contactus'" class="ms-2">Contact Us</a>
                </p>
            </div>
        </div>
    </div>
</div>